import React from "react";
import { Accordion, useAccordionButton } from "react-bootstrap";

export function AccordionToggle({
    children,
    eventKey,
    as: Component = "div",
    className,
    onClick,
    ...props
}) {
    const accordionOnClick = useAccordionButton(eventKey);

    return (
        <Component
            {...props}
            className={className}
            onClick={(e) => {
                accordionOnClick(e);

                if (onClick) {
                    onClick(e);
                }
            }}
            style={{ cursor: "pointer" }}
        >
            {children}
        </Component>
    );
}

export function AccordionCollapse({
  children,
  eventKey
}) {
  return (
    <Accordion.Collapse eventKey={eventKey}>
      {children}
    </Accordion.Collapse>
  );
}